import { Routes, Route } from "react-router-dom";
import Navbar from "./assets/components/Navbar/Navbar";
import Footer from "./assets/components/Footer/Footer";
import Home from "./assets/components/Home/Home";
import KitCustomizerPage from "./assets/pages/KitCustomizerPage";
import FormPage from "./assets/pages/FormPage";
import CartPage from "./assets/pages/CartPage";
import CheckoutPage from "./assets/pages/CheckoutPage";
import { CUSTOMIZER_ROUTES } from "./assets/config/customizerRegistry";
import AdminDashboard from "./assets/pages/AdminDashboard";
import UserDashboard from "./assets/pages/UserDashboard";
//import Login from "./assets/pages/Login"; 
import Auth from "./assets/pages/Login";

function App() {
  return (
    <div className="App">
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        {CUSTOMIZER_ROUTES.map(({ path, componentKey }) => (
          <Route
            key={`${path}-${componentKey}`}
            path={path}
            element={<KitCustomizerPage componentKey={componentKey} />}
          />
        ))}

        {/* FLOW (VERY IMPORTANT) */}
        <Route path="/details" element={<FormPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/user" element={<UserDashboard />} />
        <Route path="/login" element={<Auth />} />
       <Route path="/signup" element={<Auth />} />
       <Route path="/forgot-password" element={<Auth />} />
       <Route path="/verify-otp" element={<Auth />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
